export default function AddressView({ address }) {
  if (!address) return null;

  const parts = [
    address.line1,
    address.line2,
    address.city,
    address.state,
    address.postalCode,
    address.countryDescription,
  ].filter(Boolean);

  return <p className="max-w-[200px]">{parts.join(", ")}</p>;
}
